import React, { useState, useEffect, useRef } from 'react';

import {
  EMPLOYEES_BASE_URL,
  LOGIN_URL

} from '../config';


import { GlobalStyle } from '../GlobalStyle';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import useAuth from '../hooks/useAuth';
// Config

// Components
import Knoppie from './Knoppie'
import Header from './Header'
import Home from './Home';
import Thumb from './Thumb';
import Display from './Display';

// Hook

// Image




const Login = () => {
  const { setAuth } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const userRef = useRef();
  const errRef = useRef();

  const [formData, setFormData] = useState({ username: '', email: '', password: '' });
  const [errMessage, setErrMessage] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    userRef.current.focus()

  }, [])

  useEffect(() => {
    setErrMessage('')
  }, [formData])

  const onSubmit = async (e) => {
    e.preventDefault()
    console.log(formData)
    try {
      const response = await axios.post(LOGIN_URL,
        JSON.stringify(formData),
        {
          headers: { 'Content-Type': 'application/json' }

        }
      );

      const accessToken = response?.data?.accessToken
      const user = response?.data?.user
      console.log(JSON.stringify(response?.data))

      setAuth({ formData, accessToken, user })

      



      navigate(from, { replace: true });

    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing username or password")
      } else if (error.response?.status === 401) {
        setErrMessage("The user's email has not yet been confirmed. Please check your emails and confirm your address.")
      } else {
        setErrMessage('Login failed')
      }
      console.log(error)
    }


  }

  return (
    <>
      <Header Login={true}></Header>
      <section>

        <p ref={errRef}>
          {errMessage}
        </p>
      </section>


      <form onSubmit={onSubmit} className="FormClass">
        <h1>LOGIN:</h1>

        <label>Username</label>
        <input className="inputsize" ref={userRef} type={"text"} onChange={(e) => setFormData({ ...formData, username: e.target.value })} />
        <label>Password</label>
        <input className="inputsize" type={"password"} onChange={(e) => setFormData({ ...formData, password: e.target.value })} />

        <button>Submit</button>
      </form>
      <Knoppie
        callback={() => setFormData({ username: '', email: '', password: '' })}
        text={"Need to register?"}
        destination={"/register"}
        clickable={true}
      >

      </Knoppie>

      <GlobalStyle></GlobalStyle>


    </>
  )
};

export default Login;
